import * as React from 'react';
import { GridCustomHeaderCellProps } from '@progress/kendo-react-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { SvgIcon } from "@progress/kendo-react-common";
import { sortAscSmallIcon, sortDescSmallIcon } from '@progress/kendo-svg-icons';
import { HeaderThElement } from '@progress/kendo-react-data-tools';

const HeaderSortCell: React.FC<{ gridHeaderProps: GridCustomHeaderCellProps, sort?: Array<SortDescriptor>, children?: React.ReactNode }> = ({ children, gridHeaderProps, sort }) => {
    if (!gridHeaderProps.field)
        return null;

    const sortField = sort.filter(x => x.field == gridHeaderProps.field);
    return <HeaderThElement {...gridHeaderProps.thProps}>
        <span className="k-link" onClick={gridHeaderProps.onClick}>
            {children}
            <span className='k-sort-icon'>
                <SvgIcon icon={sortField.length > 0 ? (sortField[0].dir === 'asc' ? sortAscSmallIcon : sortDescSmallIcon) : undefined} />
            </span>
        </span>
    </HeaderThElement>;
}
export default HeaderSortCell;